import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { toneOf } from 'components/admin-organizations/wellbeingTones';

/**
 * Anillo del Índice OTRIX (SVG propio, sin librerías). Protegido = candado, nunca un cero:
 * un cero se leería como "el equipo está pésimo" cuando en realidad no hay dato.
 */
function WellbeingIndexGauge({ score = null, isProtected = false, size = 168 }) {
  const stroke = 10;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const value = isProtected || score === null || score === undefined ? 0 : score;

  return (
    <Box sx={{ position: 'relative', width: size, height: size, flex: 'none' }}>
      <Box
        component="svg"
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden
        sx={{ width: '100%', height: '100%', transform: 'rotate(-90deg)' }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
          stroke="currentColor"
          style={{ color: 'var(--otx-inner-highlight)' }}
          opacity={0.6}
        />
        <Box
          component="circle"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - value / 100)}
          sx={{
            stroke: 'currentColor',
            color: toneOf(isProtected ? null : score),
            transition: 'stroke-dashoffset 700ms cubic-bezier(0.32, 0.72, 0, 1)'
          }}
        />
      </Box>
      <Stack alignItems="center" justifyContent="center" sx={{ position: 'absolute', inset: 0 }}>
        {isProtected ? (
          <Lock sx={{ color: 'text.disabled', fontSize: size * 0.2 }} />
        ) : (
          <Typography
            sx={{
              fontSize: size * 0.27,
              fontWeight: 800,
              lineHeight: 1,
              fontVariantNumeric: 'tabular-nums',
              color: toneOf(score)
            }}>
            {score ?? '--'}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}

WellbeingIndexGauge.propTypes = {
  score: PropTypes.number,
  isProtected: PropTypes.bool,
  size: PropTypes.number
};

export default WellbeingIndexGauge;
